export enum PointConfigurationPaymentMethodEnum {
  FIXED_PRICE = "FIXED_PRICE",
  BY_CATEGORY = "BY_CATEGORY",
}
